module.exports = __webpack_public_path__ + "static/media/mcc-alcohol.8b5038c4.svg";